import React, { useState } from 'react';
import { WalletModalContext } from './useWalletModal.js';
import { WalletModal } from './WalletModal.js';
export const WalletModalProvider = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const [visible, setVisible] = useState(false);
  return React.createElement(WalletModalContext.Provider, {
    value: {
      visible,
      setVisible
    }
  }, children, visible && React.createElement(WalletModal, {
    ...props
  }));
};